import { lazy } from 'react';

export const CoursePageAsync = lazy(async () => import('./CoursePage'));
